import React, { useState, useEffect } from 'react';
import { bookingShape } from 'constants/propTypes';
import Modal from 'components/ui/Modal';
import { FormattedMessage } from 'react-intl';
import { getFullBrandNameFromBrandCode } from 'constants/fullBrandNames.js';
import MultiInventoryConflictWarningContent from './MultiInventoryConflictWarningContent';
import { shouldCheckStatusesBetweenS3AndPAO, getDiscrepencies } from './MultiInventoryConflictWarning.utils';

const MultiInventoryConflictWarning = ({ booking }) => {
  const [isOpen, toggleOpen] = useState(false);
  const [paoAndS3Mismatch, setPaoAndS3Mismatch] = useState([]);
  const shouldControlStatuses = shouldCheckStatusesBetweenS3AndPAO(booking);
  const closeModal = () => toggleOpen(false);

  useEffect(() => {
    if (shouldControlStatuses) {
      const paoAndS3MismatchData = getDiscrepencies(booking);
      setPaoAndS3Mismatch(paoAndS3MismatchData);
    }
  }, [shouldControlStatuses, booking]);

  useEffect(() => {
    if (paoAndS3Mismatch?.length) {
      toggleOpen(true);
    }
  }, [paoAndS3Mismatch]);

  return (
    <Modal
      isOpen={isOpen}
      title={
        <FormattedMessage
          id="manageBooking.paoAndS3MismatchWarningMessage"
          values={{
            PAO: getFullBrandNameFromBrandCode({ brandCode: paoAndS3Mismatch[0]?.serviceType?.brandCode })
          }}
        />
      }
      onClose={closeModal}
    >
      {shouldControlStatuses && !!paoAndS3Mismatch?.length && <MultiInventoryConflictWarningContent mismatchData={paoAndS3Mismatch} />}
    </Modal>
  );
};

MultiInventoryConflictWarning.propTypes = {
  booking: bookingShape
};

export default MultiInventoryConflictWarning;
